import { useState } from "react";

interface FormStatus {
  errorMessage: string | null;
  successMessage: string | null;
  isSubmitting: boolean;
}

export const useFormStatus = () => {
  const [status, setStatus] = useState<FormStatus>({
    errorMessage: null,
    successMessage: null,
    isSubmitting: false,
  });

  const setError = (message: string | null) => {
    setStatus((prev) => ({
      ...prev,
      errorMessage: message,
      successMessage: null,
    }));
  };

  const setSuccess = (message: string | null) => {
    setStatus((prev) => ({
      ...prev,
      successMessage: message,
      errorMessage: null,
    }));
  };

  const setSubmitting = (isSubmitting: boolean) => {
    setStatus((prev) => ({ ...prev, isSubmitting }));
  };

  const resetStatus = () => {
    setStatus({
      errorMessage: null,
      successMessage: null,
      isSubmitting: false,
    });
  };

  return {
    ...status,
    setError,
    setSuccess,
    setSubmitting,
    resetStatus,
  };
};
